<div class="app-page-card app-stack app-max-w-2xl app-mx-auto">
  <h1>New Valuation</h1>

  <div class="app-form-grid">
    <div class="app-field">
      <span>Assessor Parcel Number (APN)</span>
      <calcite-input
        type="text"
        placeholder="e.g. 4236-016-003"
        [value]="apn()"
        (input)="setApn($any($event.target).value)"
        [disabled]="loading()"
        autocomplete="off"
      ></calcite-input>
      <span class="app-muted app-text-caption">Enter the APN with dashes</span>
    </div>

    <div class="app-field">
      <span>Appeal Year</span>
      <calcite-input-number
        placeholder="e.g. 2026"
        [value]="appealYearDisplay()"
        (input)="setAppealYear($any($event.target).value)"
        [disabled]="loading()"
        min="2000"
        max="2100"
      ></calcite-input-number>
      <span class="app-muted app-text-caption">Year of the tax appeal (2000–2100)</span>
    </div>
  </div>

  @if (apiError()) {
    <p class="app-error">{{ apiError() }}</p>
  }

  @if (conflictSessionId()) {
    <div class="app-callout">
      A session for this APN and year already exists.
      <calcite-button appearance="transparent" scale="s" (click)="navigateToExisting()">
        Open existing session →
      </calcite-button>
    </div>
  }

  <div class="app-button-row">
    <calcite-button
      kind="brand"
      appearance="solid"
      scale="m"
      [disabled]="!isFormValid() || loading()"
      [loading]="loading()"
      (click)="submit()"
    >
      Start Valuation
    </calcite-button>
  </div>
</div>
